const mutations = {
    setUser: (state, payload) => {
      state.user = payload
    },
    setUserSubscription: (state, payload) => {
      state.user.plan = payload.plan
      state.user.cancelAtPeriodEnd = payload.cancelAtPeriodEnd
      state.user.currentPeriodEnd = payload.currentPeriodEnd
      state.user.isOnline = payload.isOnline
    }
}

export default mutations
